export const SET_APPS = 'SET_APPS';
export const SET_APP = 'SET_APP';
export const ADD_APP = 'ADD_APP';
export const UPDATE_APP = 'UPDATE_APP';
export const REMOVE_APP = 'REMOVE_APP';
export const CLEAR_APP = 'CLEAR_APP';
export const CLEAR_APPS = 'CLEAR_APPS';
